export function mapJasBoardHistoryFilterData(filterData, jasBoardId) {
    const filterView = [
        {
            column: 'jasBoardId',
            op: '=',
            value: jasBoardId,
        },
    ];
    if (filterData.status) {
        filterView.push({
            column: 'status',
            op: 'in',
            value: filterData.status,
        });
    }
    if (filterData.lastCheckedAt) {
        if (filterData.lastCheckedAt.from) {
            filterView.push({
                column: 'lastCheckedAt',
                op: '>=',
                value: new Date(filterData.lastCheckedAt.from).getTime(),
            });
        }
        if (filterData.lastCheckedAt.to) {
            filterView.push({
                column: 'lastCheckedAt',
                op: '<=',
                value: new Date(filterData.lastCheckedAt.to).getTime(),
            });
        }
    }
    if (filterData.lastSuccessAt) {
        if (filterData.lastSuccessAt.from) {
            filterView.push({
                column: 'lastSuccessAt',
                op: '>=',
                value: new Date(filterData.lastSuccessAt.from).getTime(),
            });
        }
        if (filterData.lastSuccessAt.to) {
            filterView.push({
                column: 'lastSuccessAt',
                op: '<=',
                value: new Date(filterData.lastSuccessAt.to).getTime(),
            });
        }
    }
    if (filterData.lastUpdatedAt) {
        if (filterData.lastUpdatedAt.from) {
            filterView.push({
                column: 'lastUpdatedAt',
                op: '>=',
                value: new Date(filterData.lastUpdatedAt.from).getTime(),
            });
        }
        if (filterData.lastUpdatedAt.to) {
            filterView.push({
                column: 'lastUpdatedAt',
                op: '<=',
                value: new Date(filterData.lastUpdatedAt.to).getTime(),
            });
        }
    }
    return filterView;
}
